import styled from 'styled-components';
import { useState } from 'react';

import logo from '../assets/rjBlack.png';
import { Link } from 'react-router-dom';

const NavBarStyle = styled.div`
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css');

  margin-bottom: 30px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    max-width: 100%;
  }

  color: ${(props) => props.theme.color.slate1000};
  background: #fff;
  #header_wrap {
    position: relative;
    font-family: 'Roboto', sans-serif;
    width: 100%;
  }

  .header_top {
    color: ${(props) => props.theme.color.darkBlue};
    height: 90px;
    display: flex;
    align-items: center;

    .header_top_inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .header_top_left {
      display: flex;
      direction: row;
      position: relative;

      .email {
        display: flex;
        margin-right: 60px;

        a {
          margin-right: 20px;
          font-size: 25px;
          color: ${(props) => props.theme.color.darkBlue};
        }
        p {
          line-height: 1.5;
          font-size: 0.9rem;

          @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
            display: none;
          }
        }
      }

      .phone {
        display: flex;

        a {
          margin-right: 20px;
          font-size: 25px;
          color: ${(props) => props.theme.color.darkBlue};
        }
        p {
          line-height: 1.5;
          font-size: 0.9rem;

          @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
            display: none;
          }
        }
      }
    }

    .header_top_right {
      display: flex;
      align-items: center;
      position: relative;

      p {
        font-size: 0.9rem;

        @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
          // visibility: hidden;
          display: none;
        }
      }

      .top_right_button a {
        background-color: ${(props) => props.theme.color.darkBlue};
        border-radius: 40px;
        margin-left: 20px;
        padding: 15px 30px;
        text-decoration: none;
        color: #fff;

        transition: background 300ms ease-in-out;

        &:hover {
          background-color: green;
          color: #fff;
        }
      }
    }
  }

  .site_header {
    border-top: 1px solid rgba(66, 66, 66, 0.2);

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      display: none;
    }

    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 90px;
    }
    .site_branding {
      width: 300px;
      color: ${(props) => props.theme.color.darkBlue};

      img {
        width: auto;
        vertical-align: middle;
        max-width: 100%;
        height: auto;
      }
    }

    .site_navigation {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .main_navigation {
        .mastermenu {
          display: flex;
          position: relative;
          list-style: none;

          .menu_item {
            position: relative;
            list-style: none;
            padding: 20px 60px 20px 0;

            /* Animate border-top from left to right on hover */
            .nav {
              text-decoration: none;
              color: ${(props) => props.theme.color.darkBlue};
              padding: 20px 0;
              position: relative;
              border-top: 2px solid transparent;
              transition: border-color 0.3s linear;
            }

            .nav::before {
              content: '';
              position: absolute;
              left: 0;
              top: -32px;
              width: 0;
              height: 2px;
              background: ${(props) => props.theme.color.darkBlue};
              transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
              z-index: 1;
            }

            &:hover > .nav::before,
            &.active > .nav::before {
              width: 100%;
            }

            &:hover > .nav,
            .nav:hover {
              border-top: 2px solid transparent;
            }

            &:hover > .sub_menu,
            .sub_menu:hover {
              visibility: visible;
              opacity: 1;
              clip: auto;
              cursor: pointer;
              animation: fadeInBottom 300ms ease;
            }

            /* Add active border-top when .active class is present */
            &.active > .nav {
              border-top: 2px solid transparent;
              padding-top: 34px;
            }

            .nav {
              &::after {
                content: '';
                position: absolute;
                margin-left: 5px;
                opacity: 0.5;
                font-family: 'Font Awesome 6 Free';
                font-weight: 900;
              }
            }
          }

          .sub_menu {
            visibility: hidden;
            opacity: 0;
            position: absolute;
            list-style: none;
            z-index: 99;
            top: 100%;
            padding: 20px 0;
            transition:
              opacity 300ms ease-in-out,
              visibility 300ms ease-in-out;
            clip: rect(1px, 1px, 1px, 1px);
            background-color: #fff;

            li {
              padding: 5px 20px;
              width: 300px;
              color: #000;

              a {
                color: ${(props) => props.theme.color.darkBlue};
                line-height: 1.5;
                text-decoration: none;

                &:hover {
                  color: ${(props) => props.theme.color.lightBlue};
                }
              }
            }
          }

          @keyframes fadeInBottom {
            from {
              opacity: 0;
              transform: translateY(25px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        }
      }

      .right_social_icons {
        display: flex;
        a {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: ${(props) => props.theme.color.grey};
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: row;
          margin-left: 10px;
          color: ${(props) => props.theme.color.darkBlue};
          text-decoration: none;
          transition: background-color 0.3s ease-in-out;
          transition: transform 0.2s ease-in-out;

          &:hover {
            background-color: ${({ theme }) => theme.color.lightBlue};
            animation: custom-beat 800ms infinite ease-in-out;
            color: #fff;
          }

          @keyframes custom-beat {
            0% {
              transform: scale(1);
            }
            100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
          }
        }
      }
    }
  }

  .mobile_header {
    display: none;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      display: block;
    }

    .mobile_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      .open-menu {
        font-size: 1.5rem;
      }

      .site_branding {
        img {
          width: 200px;
          vertical-align: middle;
          max-width: 100%;
          height: auto;
        }
      }

      .site_navigation {
        background-color: #fff;
        position: absolute;
        z-index: 999;
        width: 100%;
        top: 80px;
        padding: 30px 15px;

        .mastermenu {
          .menu_item {
            line-height: 3;

            &::after {
              content: '';
            }
            a {
              text-decoration: none;
              color: ${({ theme }) => theme.color.darkBlue};
              font-family: 'Poppins', sans-serif;
              font-weight: bold;
            }

            list-style: none;
            .sub_menu {
              // display: none;
              list-style: none;
              li {
                a {
                  text-decoration: none;
                }
              }
            }
          }
        }
      }
    }
  }
`;

const NavBar = () => {
  const [isClick, setIsClick] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
    setIsClick(!isClick); // Toggle submenu
  };

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };
  return (
    <>
      <NavBarStyle>
        <div id="NavBar_wrap">
          <div className="header_top">
            <div className="container">
              <div className="header_top_inner flex">
                <div className="top_left_content">
                  <div className="header_top_left">
                    <div className="email">
                      <a href="mailto:info@radeintegratedservices.co.uk">
                        <i className="fa-regular fa-envelope"></i>
                      </a>
                      <p>
                        <label htmlFor="">
                          If you have any queries
                          <br />
                          info@radeintegratedservices.co.uk
                        </label>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="header_top_right">
                  <div className="right-item time">
                    <p>Opening Hours: 9:00AM - 5:00PM</p>
                  </div>
                  <div className="right-item top_right_button">
                    <a href="/contact" target="_self">
                      Get a Quote
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="site_header">
            <div className="container">
              <div className="row">
                <div className="site_branding">
                  <a href="/" rel="home" title="rade">
                    <img src={logo} alt="rade" />
                  </a>
                </div>
                <div className="site_navigation">
                  <nav className="main_navigation">
                    <ul className="mastermenu">
                      <li className="menu_item">
                        <Link className="nav">Services</Link>
                        <ul className="sub_menu">
                          <li>
                            <a href="/commercial-cleaning">
                              Commercial Cleaning
                            </a>
                          </li>
                          <li>
                            <a href="/residential-cleaning">
                              Residential Cleaning
                            </a>
                          </li>

                          <li>
                            <a href="/specialized-cleaning">
                              Specialized Cleaning
                            </a>
                          </li>
                          <li>
                            <a href="/transport-and-logistics">
                              Transport & Logistics
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="menu_item">
                        <Link className="nav">Company</Link>
                        <ul className="sub_menu">
                          <li>
                            <a href="/about">About us</a>
                          </li>
                          <li>
                            <a href="/Our Team">Our Team</a>
                          </li>
                          <li>
                            <a href="/Gallery">Gallery</a>
                          </li>
                        </ul>
                      </li>
                      <li className="menu_item">
                        <Link className="nav">Contact</Link>
                        <ul className="sub_menu">
                          <li>
                            <a href="/contact">Contact Us</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </nav>
                  <div className="right_social_icons">
                    <a
                      className="fa"
                      href="https://www.facebook.com/share/1L9c5YmUit/?mibextid=wwXIfr"
                      title="Facebook"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-facebook-f custom-icon"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/radeintegratedservicesltd?igsh=eGsxczI2ZmJtdGRy&utm_source=qr"
                      title="Instagram"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@radeintegratedservices?_t=ZN-8w3lzrVdp1q&_r=1"
                      title="Tiktok"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-tiktok"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mobile_header">
            <div className="container">
              <div className="mobile_row">
                <div className="site_branding">
                  <a href="/" rel="home" title="rade">
                    <img src={logo} alt="rade" />
                  </a>
                </div>
                <div className="open-menu" onClick={toggleNav}>
                  {/* <i class="fa-solid fa-x"></i> */}
                  {!isClick ? (
                    <i class="fa-solid fa-bars"></i>
                  ) : (
                    <i class="fa-solid fa-x"></i>
                  )}
                  {/* <i class="fa-solid fa-bars"></i>
                                        <i class="fa-solid fa-x"></i> */}
                </div>
                {isNavVisible && (
                  <div className="site_navigation">
                    <nav className="main_navigation">
                      <ul className="mastermenu">
                        <li className="menu_item">
                          <Link
                            className="nav"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleMenu('services');
                            }}
                          >
                            Services
                          </Link>
                          {openMenu === 'services' && (
                            <ul className="sub_menu">
                              <ul className="sub_menu">
                                <li>
                                  <a href="/commercial-cleaning">
                                    Commercial Cleaning
                                  </a>
                                </li>
                                <li>
                                  <a href="/residential-cleaning">
                                    Residential Cleaning
                                  </a>
                                </li>

                                <li>
                                  <a href="/transport-and-logistics">
                                    Transport & Logistics
                                  </a>
                                </li>
                                <li>
                                  <a href="/specialized-cleaning">
                                    Specialized Cleaning
                                  </a>
                                </li>
                              </ul>
                            </ul>
                          )}
                        </li>
                        <li className="menu_item">
                          <Link
                            className="nav"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleMenu('company');
                            }}
                          >
                            Company
                          </Link>
                          {openMenu === 'company' && (
                            <ul className="sub_menu">
                              <li>
                                <a href="/about">About us</a>
                              </li>
                              <li>
                                <a href="/our team">Our Team</a>
                              </li>
                              <li>
                                <a href="/gallery">Gallery</a>
                              </li>
                            </ul>
                          )}
                        </li>
                        <li className="menu_item">
                          <Link
                            className="nav"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleMenu('contact');
                            }}
                          >
                            Contact
                          </Link>
                          {openMenu === 'contact' && (
                            <ul className="sub_menu">
                              <li>
                                <a href="/contact">Contact Us</a>
                              </li>
                            </ul>
                          )}
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </NavBarStyle>
    </>
  );
};

export { NavBar };
